import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const classEnrollment = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    status: z
      .enum(['Enrolled', 'In Progress', 'Completed', 'Dropped'])
      .nullable()
      .optional()
      .describe('Current enrollment status.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    trainingClassId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to TrainingClass'),

    candidate: belongsTo('Candidate'),

    trainingClass: references('TrainingClass', 'trainingClassId'),
  })
  .describe("Tracks a candidate's enrollment in a training class.")
  .as('ClassEnrollment');

export { classEnrollment as classEnrollmentSchema };
